import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const FSC_TIER_NAMES = {
  STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "fscTierSelector.tiers.STARTER"
  }),
  PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "fscTierSelector.tiers.PROFESSIONAL"
  }),
  ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "fscTierSelector.tiers.ENTERPRISE"
  })
};